import { Component,Input, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators,FormGroupDirective} from '@angular/forms';
import { ApiService } from '../api.service';
import { ObservablesService } from '../observables.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Subject } from "rxjs";
import {Observable} from 'rxjs';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import {map, startWith} from 'rxjs/operators';
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { _ } from 'underscore';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import {default as _rollupMoment} from 'moment';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-invoice-direct-amount-form',
  templateUrl: './invoice-direct-amount-form.component.html',
  styleUrls: ['./invoice-direct-amount-form.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
 ],
})
export class InvoiceDirectAmountFormComponent implements OnInit {
  parties:any = []
  options:any = []
  filteredOptions: Observable<string[]>;
  invoiceForm: FormGroup;
  invoice_date: string | number | Date;
  amount: any=0;
  totamt: number=0;
  gst_total_amt:number = 0;
  _editInvoiceInfo:any={editStatus:false};
  loggedUserInfo:any=[]
  business_id:any;
  parent_id:any;
  tags:any=[]
  editTags:any=[];
  user_id:any;
  editInvoiceId:any;
  editStatus:boolean = false
  editOnceStatus:boolean=false
  tagIterateSubscriber:any;
  tagIterationObserver:any = new Subject<any>();
  invoiceNumberSubscriber:any
  refreshTagsSubscriber:any
  existingInvoiceStatus: boolean = false;
  party_gstin:any=null;
  productDetails:any=[]
  @Input() set editInvoiceInfo(editInvoiceInfo){
    this._editInvoiceInfo = editInvoiceInfo;
    // console.log("this._editInvoiceInfo==",this._editInvoiceInfo)
  }
  constructor(private router:Router, private observables:ObservablesService,private formBuilder: FormBuilder, private api:ApiService, private datePipe: DatePipe) {
    // if(this.router.getCurrentNavigation().extras.state !== undefined){
    //   this._editInvoiceInfo = this.router.getCurrentNavigation().extras.state
    // }

  }
  ngOnDestroy(){
    this.invoiceNumberSubscriber.unsubscribe()
    this.refreshTagsSubscriber.unsubscribe()
  }

  ngOnInit() {
    this.refreshTagsSubscriber = this.observables.refreshTagsStatus.subscribe(()=>{
      this.getTags();
    })

    this.invoiceNumberSubscriber = this.observables.setInvoiceNumberStatus.subscribe((res)=>{
      this.invoiceForm.patchValue({invoice_number:parseInt(res.invoice_number) + 1})
    })
    this.api.getLoggedUserInfo().then((res:any)=>{
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];
        if(this.loggedUserInfo.level == 1){
          this.business_id = this.loggedUserInfo.business_id
          this.user_id = this.loggedUserInfo.id
        }else if(this.loggedUserInfo.level > 1){
          this.user_id = this.loggedUserInfo.id
          this.parent_id = this.loggedUserInfo.parent_id
          this.business_id = this.loggedUserInfo.business_id
        }else{
          this.api.logOut()
        }

        this.getParty();
        this.getTags();
        if(!this._editInvoiceInfo.editStatus) {
          this.getLastInvoiceId();

        }
      }

    })
    this.createForm()
  }

    createForm(){

      if(!this._editInvoiceInfo.editStatus) {

        this.editStatus = false;
        this.editOnceStatus = false;
        this.invoiceForm = this.formBuilder.group({
          invoice_number:[{value:''}, Validators.compose([Validators.required,Validators.pattern(/^[0-9]{1,6}$/)])],
          party_id:[null, Validators.required],
          user_id:[null],
          party_name:[null, Validators.required],
          invoice_date:{value:moment(),disabled:true},
          delivery_to:null,
          total_amount: [this.totamt, Validators.required],
          gst_total_amount:this.gst_total_amt,
          tags:[null],
          note:[null]
        });
      }else{
        if(!this.editOnceStatus){
          this.editInvoice()
        }
      }

    }

    editInvoice(){
      if(this._editInvoiceInfo.editStatus){
        this.editOnceStatus = true;
        this.editStatus = true;
        this.editInvoiceId = this._editInvoiceInfo.data.id;

          // console.log("edit Invoice date===",this._editInvoiceInfo.data)
          this.invoiceForm = this.formBuilder.group({
            invoice_number:[{value:this._editInvoiceInfo.data.invoice_number,disabled:true}, Validators.compose([Validators.required,Validators.pattern(/^[0-9]{1,6}$/)])],
            party_id:this._editInvoiceInfo.data.party_id,
            user_id:this._editInvoiceInfo.data.user_id,
            party_name:this._editInvoiceInfo.data.business_name,
            invoice_date:{value:new Date(this._editInvoiceInfo.data.invoice_date),disabled:true},
            payment_status:this._editInvoiceInfo.data.payment_status,
            delivery_to:this._editInvoiceInfo.data.delivery_to,
            total_amount: [this._editInvoiceInfo.data.total_amount, Validators.required],
            gst_total_amount:this._editInvoiceInfo.data.gst_total_amount,
            tags:[null],
            note:this._editInvoiceInfo.data.note
          });
          // this.selectedParty = {id:this._editInvoiceInfo.data.party_id,full_name:this._editInvoiceInfo.data.full_name};
          this.editTags=[]
          this.api.send("findDb",{
            table:"slip_invoice_tags",
            conditions:[{invoice_id:this._editInvoiceInfo.data.id}]
          }).then((res:any)=>{
            if(res.data.length > 0){
              for(let i=0;i<res.data.length;i++){
                this.editTags.push(res.data[i].tag_id)
                if(i==res.data.length -1){

                  this.invoiceForm.patchValue({tags:this.editTags})
                  // console.log("tags=",tags)
                }
              }

            }
          })
      }

    }

    cancelUpdate(){

      this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/dashboard')])
    }



    updateInvoice(formValue,formDirective:FormGroupDirective){
      if(confirm("Are you sure to update new changes in Invoice?")){
        let value = this.invoiceForm.getRawValue();

        // console.log("invoice edtiting value==",value)

        let date:any = new Date(value.invoice_date);
        let invoice_date:any=this.datePipe.transform(date, 'yyyy-MM-dd'); //whatever format you need.

        this.api.send("updateDb",{
          table:"invoices",
          data:{
            invoice_number:value.invoice_number,
            party_id:value.party_id,
            invoice_date:invoice_date,
            gst_total_amount:0,
            exclude_gst_total_amount: 0,
            total_amount: parseFloat(value.gst_total_amount) + parseFloat(value.total_amount),
            balance:  parseFloat(value.gst_total_amount) + parseFloat(value.total_amount),
            delivery_to:value.delivery_to,
            user_id:value.user_id,
            note:value.note
          },
          conditions:[{id:this.editInvoiceId}]
        }).then((result:any)=>{
          if(result.data.affectedRows){

            if(value.tags){
              if(this.editTags.length > 0){
                let intersectionArr = _.intersection(value.tags,this.editTags);
                // console.log("intersection=",_.intersection(value.tags,this.editTags));
                let differenceArr1 = _.difference(value.tags,intersectionArr)
                // console.log("differenceArr1==",differenceArr1)
                let differenceArr2 = _.difference(this.editTags,intersectionArr)
                // console.log("differenceArr2==",differenceArr2)
                if(differenceArr1.length > 0 && differenceArr2.length > 0){
                  //add from diff1 and remove from diff2
                  this.saveTags(differenceArr1,this.editInvoiceId).then((res:any)=>{
                    this.removeTags(differenceArr2,this.editInvoiceId).then((res1:any)=>{
                      this.resetAll(formDirective)
                    })
                  })
                }else if(differenceArr1.length == 0 && differenceArr2.length == 0){
                  //tags not updated same as before
                  this.resetAll(formDirective)
                }else if(differenceArr1.length > 0 && differenceArr2.length == 0){
                  //add from diff1
                  this.saveTags(differenceArr1,this.editInvoiceId).then((res:any)=>{
                    this.resetAll(formDirective)
                  })
                }else if(differenceArr1.length == 0 && differenceArr2.length > 0){
                  //remove from diff2
                  this.removeTags(differenceArr2,this.editInvoiceId).then((res1:any)=>{
                    this.resetAll(formDirective)
                  })
                }
              }else{
                //update all
                this.saveTags(value.tags,this.editInvoiceId).then((res:any)=>{
                  this.resetAll(formDirective)
                })
              }

              }else{
                this.resetAll(formDirective)
              }


          }else{
            this.observables.showToastMessage({type:0,message:'Invoice Not Updated, Try again...'});
          }
        })
      }
    }

    addTags(){
        this.observables.tagPopupStatus.next()
    }

    removeTags(tags,invoice_id){
      return new Promise((resolve)=>{
        let k= 0;
        this.tagIterateSubscriber = this.tagIterationObserver.subscribe((k)=>{
          if(k >= tags.length){
            this.tagIterateSubscriber.unsubscribe()
            resolve(true)
          }else{
            this.api.send("deleteDb",{
              table:'slip_invoice_tags',
              conditions:[{invoice_id:invoice_id,tag_id:tags[k]}]
            }).then((res:any)=>{

              this.tagIterationObserver.next(k+1);
            })
          }
        })
        this.tagIterationObserver.next(k)
      })
    }

    getLastInvoiceId(){
      this.api.send("findDb",{
        fields:["invoice_number"],
        table:"invoices",
        conditions:[{business_id:this.business_id}],
        order:"invoice_number DESC",
        limit:1
      }).then((res:any)=>{

        if(res.data.length > 0){

          this.invoiceForm.patchValue({invoice_number:parseInt(res.data[0].invoice_number) + 1})
        }else{
          this.invoiceForm.patchValue({invoice_number:1})
        }

      })
    }


    getParty(){

     this.api.send("findDb",{
       table:"parties",
       conditions:[{business_id:this.business_id}],
       order:"id DESC"
     }).then((result:any)=>{
       // console.log("results=",result)
       this.parties = result.data;
       this.options = result.data;

       this.filteredOptions = this.invoiceForm.get('party_name').valueChanges
       .pipe(
         startWith(''),
         map(value => this._filter(value))
       );
     });

    }

    private _filter(value: any): string[] {
      if(value){

        const filterValue = value.toLowerCase();
        return this.options.filter(option => option.business_name.toLowerCase().includes(filterValue));
      }
    }


    onSelectionChanged(_event: any,userData) {

      if (_event.isUserInput) {

        // console.log("selected Party==",userData)
        this.invoiceForm.patchValue({party_id:userData.id,user_id:userData.user_id})
        this.party_gstin = userData.gstin;
      }

    }

    getTag(tag_id){
      for(let i=0;i<this.tags.length;i++){
        if(this.tags[i].id == tag_id){
          return this.tags[i].tag_name
        }
      }
    }
    getTags(){
     this.api.send("findDb",{
       table:"tags",
       conditions:[{business_id:this.business_id}]
     }).then((result:any)=>{
       this.tags=result.data
     })
    }

    getnum(value){
      return parseFloat(value)
    }

    submitData(formValue,formDirective:FormGroupDirective,printStatus){
      let value = this.invoiceForm.getRawValue();
      console.log("value=",value)

      this.productDetails = []
      let date:any = new Date(value.invoice_date);
      let invoice_date:any=this.datePipe.transform(date, 'yyyy-MM-dd'); //whatever format you need.

      this.api.send("insertDb",{
        table:"invoices",
        data:{
          business_id:this.business_id,
          invoice_number:value.invoice_number,
          party_id:value.party_id,
          invoice_date:invoice_date,
          gst_total_amount:0,
          exclude_gst_total_amount:0,
          total_amount: parseFloat(value.gst_total_amount) + parseFloat(value.total_amount),
          balance:  parseFloat(value.gst_total_amount) + parseFloat(value.total_amount),
          delivery_to: value.delivery_to,
          user_id:value.user_id,
          direct_invoice_status:1,
          note:value.note
        }
      }).then((result:any)=>{
        if(result.data.affectedRows){
          this.addToMaster(value,invoice_date,result.data.insertId).then((resp:any)=>{
            if(resp.status){
              if(value.tags){

                this.saveTags(value.tags,result.data.insertId).then((tagRes:any)=>{
                  this.resetAll(formDirective,printStatus,result.data.insertId)
                })
              }else{
                this.resetAll(formDirective,printStatus,result.data.insertId)
              }
            }else{
              this.observables.showToastMessage({type:1,message:"Invoice Can\'t Create in Master, Try again..."})
            }

          })
        }else{
          this.observables.showToastMessage({type:1,message:"Invoice Can\'t Create in Master, Try again..."})
        }
      })
    }

    addToMaster(value,invoice_date,invoice_id){
      let tags = []
      if(value.tags) {
        value.tags.filter(item=>{
          for(let i=0;i<this.tags.length;i++){
            if(item == this.tags[i].id){
              tags.push({tag_id:this.tags[i].id,tag:this.tags[i].tag_name})
              break;
            }
          }
        })
      }

      return new Promise((resolve)=>{
        this.api.send("insertDb",{
          table:"master_invoices",
          data:{
            business_id:this.business_id,
            invoice_id:invoice_id,
            invoice_number:value.invoice_number,
            party_id:value.party_id,
            party_name:value.party_name,
            gstin:this.party_gstin,
            invoice_date:invoice_date,
            user_name:this.loggedUserInfo.username,
            exclude_gst_total_amount:value.total_amount,
            total_amount: parseFloat(value.gst_total_amount) + parseFloat(value.total_amount),
            gst_total_amount:value.gst_total_amount,
            balance:  parseFloat(value.gst_total_amount) + parseFloat(value.total_amount),
            delivery_to: value.delivery_to,
            note:value.note,
            user_id:value.user_id,
            direct_invoice_status:1,
            tags:(tags.length)?JSON.stringify(tags):null
          }
        }).then((result:any)=>{
          // console.log("master result=",result)
          if(result.data.affectedRows){
            resolve({status:true,master_invoice_id:result.data.insertId});
          }else{
            resolve({status:false});

          }
        })
      })
    }

    resetAll(formDirective,printStatus=false,invoice_id=false){
      // console.log("resetting==",this.editStatus)
      formDirective.resetForm();
      this.invoiceForm.reset();
      if(this.editStatus){
        this.editStatus = false;
        this.editOnceStatus = false;
        this.observables.showToastMessage({type:0,message:'Invoice Updated...'});
        this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/dashboard')])
      }else{

        this.invoiceForm.patchValue({invoice_date:moment(),gst_total_amount:this.gst_total_amt})

        this.editStatus = false;
        this.editOnceStatus = false;
        if(printStatus){
          this.api.send("findDb",{
            fields:["I.*, P.*,I.id as id"],
            table:"invoices as I",
            joins:[{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]}],
            conditions:[{"I.id":invoice_id}],
            order:"I.id DESC"
          }).then((res:any)=>{
            // console.log("unpaidInvoices==",this.unpaidInvoices)
            this.observables.invoiceViewStatus.next({id:invoice_id,invoiceData:res.data[0]})
          })
          // this.observables.showinvoiceViewStatus.next({id:result.data.insertId,invoiceStatus:true,invoiceinvoiceStatus:true})
        }

        this.getLastInvoiceId()
        this.observables.showToastMessage({type:0,message:"Invoice Created Successfully."})
      }
    }

  saveTags(tags,invoice_id){
    return new Promise((resolve)=>{
      let k= 0;
      this.tagIterateSubscriber = this.tagIterationObserver.subscribe((k)=>{
        if(k >= tags.length){
          this.tagIterateSubscriber.unsubscribe()
          resolve(true)
        }else{
          this.api.send("insertDb",{
            table:'slip_invoice_tags',
            data:{
              business_id:this.loggedUserInfo.business_id,
              invoice_id:invoice_id,
              tag_id:tags[k]
            }
          }).then((res:any)=>{

            this.tagIterationObserver.next(k+1);
          })
        }
      })
      this.tagIterationObserver.next(k)
    })
  }

  checkInvoiceNo(value){
    // console.log("Slip no= : ",value);
    // return new Promise((resolve)=>{

    if(value.length > 0){
      let data={
        invoice_number:value,
        business_id:this.loggedUserInfo.business_id
      }

      this.api.send("findDb",{
        table:"invoices",
        conditions:[data]
      }).then((result:any)=>{
        // console.log("Invoice No==",result)
        if(result.data.length > 0){

          this.existingInvoiceStatus = true;
          // resolve(true)
        }else{
          this.existingInvoiceStatus = false;
          // resolve(false)
        }
      })
    }else{
      this.existingInvoiceStatus = false;
      // resolve(false)
    }
    // })

  }
}
